"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCountByDate = instanceOfCountByDate;
exports.CountByDateFromJSON = CountByDateFromJSON;
exports.CountByDateFromJSONTyped = CountByDateFromJSONTyped;
exports.CountByDateToJSON = CountByDateToJSON;
exports.CountByDateToJSONTyped = CountByDateToJSONTyped;
/**
 * Check if a given object implements the CountByDate interface.
 */
function instanceOfCountByDate(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('count' in value) || value['count'] === undefined)
        return false;
    return true;
}
function CountByDateFromJSON(json) {
    return CountByDateFromJSONTyped(json, false);
}
function CountByDateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'],
        'count': json['count'],
    };
}
function CountByDateToJSON(json) {
    return CountByDateToJSONTyped(json, false);
}
function CountByDateToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'count': value['count'],
    };
}
//# sourceMappingURL=CountByDate.js.map